module.exports = __webpack_public_path__ + "img/azlogo-01 3@2x.471d101c.png";